import React, { FC, useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import classes from "../../styles/NewTable.module.css";

interface PaginationProps {
  totalItems: number;
  itemsPerPage: number;
  currentPage?: number;
  onPageChange?(selectedItem: { selected: number }): void;
  style?: React.CSSProperties;
}

const Pagination: FC<PaginationProps> = ({
  totalItems,
  itemsPerPage,
  currentPage = 1,
  onPageChange,
  style,
}) => {
  const [internalCurrentPage, setInternalCurrentPage] = useState(
    Math.max(0, currentPage - 1)
  );

  const pageCount = totalItems === 0 ? 0 : Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    const newPage = Math.max(0, currentPage - 1);
    setInternalCurrentPage(newPage);
  }, [currentPage]);

  const handlePageChange = (selectedItem: { selected: number }) => {
    setInternalCurrentPage(selectedItem.selected);
    onPageChange?.(selectedItem);
  };

  const startEntry =
    totalItems === 0 ? 0 : internalCurrentPage * itemsPerPage + 1;
  const endEntry = Math.min(
    (internalCurrentPage + 1) * itemsPerPage,
    totalItems
  );

  return (
    <div className={classes.paginationContainer} style={style}>
      {pageCount > 1 && (
        <div className={classes.paginationContainer_2}>
          <p>
            Showing {startEntry} to {endEntry} of {totalItems} entries
          </p>
          <ReactPaginate
            breakLabel="..."
            pageRangeDisplayed={5}
            previousLabel="Previous"
            nextLabel="Next"
            pageCount={pageCount}
            forcePage={internalCurrentPage}
            onPageChange={handlePageChange}
            activeClassName={classes.paginationActiveLink}
            containerClassName={classes.paginationButtons}
            previousClassName={classes.paginationPrevious}
            nextClassName={classes.paginationNext}
            disabledClassName={classes.paginationDisabled}
          />
        </div>
      )}
    </div>
  );
};

export default Pagination;
